import { FieldError } from 'react-hook-form';
import TextSmall from './TextSmall';

export default function ErrorText({ error }: { error: string | FieldError }) {
    return (
        <TextSmall className="absolute top-full left-0 mt-1 text-sm text-red-400 max-lg:line-clamp-1 lg:line-clamp-2">
            {typeof error === 'string' ? error : `${error.message}`}
        </TextSmall>
    );
}
